import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {Configuration} from "../models/Configuration";

export class ConfigurationRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    appropriateConfiguration($platform: string): Promise<Configuration|null> {
        return this.client.get<Configuration|null>(`/app/appropriateConfiguration`, {
            headers: {
                "X-Appercode-Platform": $platform
            }
        })
        .then(({data}) => {
            return data ? new Configuration(data) : null;
        })
    }

}